module.exports = __webpack_public_path__ + "static/media/carousel_one_medium_720x480.355f67f3.jpg";